import { getAppDomainPreset, normalizeAppRuntimeEnv } from '@/config/domainPresets'
import { API_ENDPOINTS } from '@/config/apiEndpoints'

/** 开发环境经 Vite 代理，避免浏览器跨域（见 vite.config.ts server.proxy） */
const metaEnv = (import.meta as ImportMeta & {
  env?: {
    DEV?: boolean | string
    MODE?: string
    VITE_APP_ENV?: string
  }
}).env ?? {}
const processEnv = (globalThis as typeof globalThis & {
  process?: {
    env?: {
      CG_APP_ENV?: string
      NODE_ENV?: string
      VITE_APP_ENV?: string
    }
  }
}).process?.env ?? {}
const devFlag = metaEnv.DEV
const dev = devFlag === true || String(devFlag) === 'true'
  || processEnv.NODE_ENV === 'development'
const appEnv = normalizeAppRuntimeEnv(
  metaEnv.MODE
  || metaEnv.VITE_APP_ENV
  || processEnv.VITE_APP_ENV
  || processEnv.CG_APP_ENV,
)
const domains = getAppDomainPreset(appEnv)
const prodDomains = getAppDomainPreset('prod')
const testRuntimeCdn = 'https://testcdn.66rpg.com'
const isTestRuntimeEnv = appEnv.includes('test')

/**
 * 移除域名或路径右侧多余斜杠。
 * @param value 原始域名或路径。
 * @returns 去掉末尾斜杠后的字符串。
 */
function trimRightSlash(value: string): string {
  return String(value || '').replace(/\/+$/g, '')
}

/**
 * 统一管理网页端依赖的业务域名和开发代理地址。
 */
export class BaseWebUrl {
  baseCdn1 = trimRightSlash(domains.cdn1)
  baseWebsite = dev ? '/__dev_proxy_www/' : `${trimRightSlash(domains.website)}/`
  baseCg = dev ? '/__dev_proxy_cg/' : `${trimRightSlash(domains.cg)}/`
  basePassport = dev ? '/__dev_proxy_passport/' : `${trimRightSlash(domains.passport)}/`
  baseMaterialCdn = dev ? '/api/sharedlib/' : `${trimRightSlash(prodDomains.cdn2)}/sharedlib/`
  baseProjectResourceCdn = `${trimRightSlash(isTestRuntimeEnv ? testRuntimeCdn : domains.cdn1)}/shareres/`
  baseOfficialProjectResourceCdn = `${trimRightSlash(prodDomains.cdn1)}/shareres/`
  ossBadgeUrl = `${this.baseCg}${API_ENDPOINTS.cg.ossCredential.replace(/^\/+/g, '')}`
}